import React from 'react';
import { PropTypes } from 'prop-types';
import ProjectCard from '../../../project-card';

const Section = (props) => {
  const {
    title,
    edit,
    hasEdit,
    children,
    href,
    editText,
  } = props;

  if (!hasEdit) {
    return (
      <ProjectCard title={title}>
        {children}
      </ProjectCard>
    );
  }

  return (
    <ProjectCard
      title={title}
      edit={edit}
      editText={editText}
      href={href}
    >
      {children}
    </ProjectCard>
  );
};

Section.propTypes = {
  title: PropTypes.string.isRequired,
  edit: PropTypes.func,
  children: PropTypes.node.isRequired,
  hasEdit: PropTypes.bool.isRequired,
  href: PropTypes.string,
  editText: PropTypes.string,
};

Section.defaultProps = {
  editText: null,
  href: null,
  edit: undefined,
};

export default Section;
